<template>
<div class="flex flex-wrap flex-col pb-24 pt-16">
  <h2 class="text-dark text-center">
    {{$t(`message.tariff.head`)}}
  </h2>
  <div class="tarif-wrapper">
    <template v-for="data in getTariffs">
      <div :key="data.id" class="flex flex-wrap flex-col pb-12 pt-6 tarif-box">
        <h3 class="text-primary pb-6">{{ data['tarif_name'] }}</h3>
        <div :class="getContainerClass(data['tarif_code'])">
          <img class="w-80 h-80 md:ml-10" :src="getContainerImg(data['tarif_code'])" alt="image" />
          <ul class="pt-6 tariff-list">
            <template v-for="info in downData['main'][data['tarif_code']]">
              <li :key="info['id']" class="pb-4">
                {{$t(`message.tariff.option${info['id']}.header`) | disableStar}}:
                <span v-if="notEmpty(info['val'])">
                  {{info['val']}}
                </span>
                <span v-if="info['trans']">
                  {{$t(`message.tariff.option${info['id']}.value.${info['trans']}`)}}
                </span>
                <template v-if="downDataObj['star'][data['tarif_code']][info['id']]">
                  , {{$t(`message.tariff.option${info['id']}.star`) | disableStar}}:
                  <span v-if="notEmpty(info['val'])">
                    {{downDataObj['star'][data['tarif_code']][info['id']]['val']}}
                  </span>
                    <span v-if="info['trans']">
                    {{$t(`message.tariff.option${info['id']}.starValue.${info['trans']}`)}}
                  </span>
                </template>
              </li>
            </template>
          </ul>
        </div>
        <div v-if="isNaN(parseInt(tariffCodeInfo[data['tarif_code']]['service']))" class="pt-6 pb-6 font-semibold">
          {{tariffCodeInfo[data['tarif_code']]['service']}}
        </div>
        <div v-else class="pt-6 pb-6 font-semibold">
          {{$t('message.tariff.price', {amount: tariffCodeInfo[data['tarif_code']]['service']})}}
        </div>
        <div class="buttons-wrap">
          <button @click="changeCurrentTariff(data['tarif_name'])"
            v-if="!data['sign_block']"
            class="buttons__btn text-primary font-medium mr-4">
            {{$t(`message.tariff.change`)}}
          </button>
          <button
            class="buttons__btn text-primary font-medium"
            @click="$router.push('/tariffs/compare')"
          >
            {{$t(`message.tariff.compare`)}}
          </button>
        </div>
      </div>
    </template>
  </div>
</div>
</template>

<script>
import {mapGetters} from 'vuex'
import downData from '@/mixins/downData'
import * as start from '@/assets/images/tariffs/start.svg'
import * as standart from '@/assets/images/tariffs/standart.svg'
import * as business from '@/assets/images/tariffs/business.svg'
import * as businessplus from '@/assets/images/tariffs/businessplus.svg'
import { isNil } from 'lodash'

export default {
  name: 'AllTariffs',
  data: () => ({
    showPopup: false
  }),
  mixins: [downData],
  methods: {
    notEmpty (val) {
      return !isNil(val)
    },
    getContainerClass (code) {
      switch (code) {
      case 'STANDART_0':
      case 'BUSINESS':
        return 'flex flex-col md:flex-row block-wrap'
      case 'STANDART':
      case 'BUSINESS_PLUS':
        return 'flex flex-wrap flex-col md:flex-row md:flex-row-reverse md:justify-end md:content-center block-wrap'
      }
    },
    getContainerImg (code) {
      switch (code) {
      case 'STANDART_0':
        return start
      case 'STANDART':
        return standart
      case 'BUSINESS':
        return business
      case 'BUSINESS_PLUS':
        return businessplus
      }
    }
  },
  computed: {
    ...mapGetters('utils', ['getTariffs', 'getTemplate', 'getUpData', 'getTariffPrice'])
  }
}
</script>

<style scoped>

</style>
